type SelectableVersion = {
  ncFileVersionId: number;
};

// Toggles a version in a max-two comparison selection: removes it if already selected, appends it when there is room, else replaces the second slot.
export const toggleVersionInSelection = <T extends SelectableVersion>(selection: T[], version: T): T[] => {
  const index = selection.findIndex((v) => v.ncFileVersionId === version.ncFileVersionId);
  if (index >= 0) {
    return selection.filter((v) => v.ncFileVersionId !== version.ncFileVersionId);
  }

  if (selection.length < 2) {
    return [...selection, version];
  }

  return [selection[0], version];
};
